const e = {
  Fee: "FEE",
  Ekit: "EKIT",
  Pkit: "PKIT",
  LateFee: "LATE_FEE"
};
export {
  e as A
};
//# sourceMappingURL=AccountProductType-d7c19476.mjs.map
